import { env } from '~/lib/env';
import type { variables } from '~/lib/variables';
import type { FeatureFlagKey } from '~/modules/experiments/features';
import { isLocalhost } from '~/modules/experiments/utils/isLocalhost';

import { useFeatureFlagContext } from './useFeatureFlagContext';

function useFeatureFlags(keys: FeatureFlagKey[]) {
  const client = useFeatureFlagContext();

  return keys.map((key) => {
    if (isLocalhost()) {
      const localEnvKey = `VITE_${key.toUpperCase()}`;
      const localValue = env(localEnvKey as keyof typeof variables, false);

      if (localValue !== undefined && localValue !== '') {
        return localValue === 'true';
      }
    }

    return client?.getBooleanValue(key, false) || false;
  });
}

export { useFeatureFlags };
